module.exports = function getResource(label, vars = []) {
    const resources = {
        colorIQHistoryTitle: 'Vos résultats Color IQ enregistrés',
        latest: 'ACTUEL',
        captured: 'Capturé',
        gotIt: 'Compris',
        viewAll: 'Voir tout'
    };

    return resources[label];
};
